// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"274d5243","242":"274d5243","299":"bf65452a","488":"c2449bda","534":"ea24a1e5"}[chunkId] + ".css";
};